export enum DatasetFieldScope {

    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
    NRI = 'NRI',
  //  TENSORFLIGHT = 'TENSORFLIGHT',
    MUNICHRE = 'MUNICHRE',
    E2VALUE = 'E2VALUE',
    CUSTOM_SCORE = 'CUSTOM_SCORE',
    PRECISELY_BUILDING = 'PRECISELY_BUILDING',
    CONSOLIDATED_RISK_SCORE = 'CONSOLIDATED_RISK_SCORE',
    PRECISELY_CRIME = 'PRECISELY_CRIME',
    PRECISELY_WILDFIRE_RISK = 'PRECISELY_WILDFIRE_RISK'
}
